module.exports = __webpack_public_path__ + "static/media/associate.52aae41e.png";